import AllUsersPage from "./AllUsersPage";
import CompanySelector from "./CompanySelector";
import DemoDataProgress from "./DemoDataProgress";
import Infra from "./Infra";
import MaintenanceStatus from "./MaintenanceStatus";
import NewCompany from "./NewCompany";
import {
  AccountBalance as CompaniesIcon,
  Announcement as MaintenanceStatusIcon,
  DatasetOutlined as DemoDataIcon,
  FactCheckRounded as ConfigStagingIcon,
  PeopleRounded as AllUsersIcon,
  RocketLaunch as RocketLaunchIcon,
} from "@mui/icons-material";
import ConfigStagingPage from "components/admin/configStaging/ConfigStagingPage";
import Footer from "components/common/Footer";
import Navigation from "components/common/Navigation";
import { Navigate, Route, Routes } from "react-router-dom";

const GlobalConsole = () => {
  const menuItems = [
    {
      text: "Maintenance Status",
      icon: <MaintenanceStatusIcon />,
      route: "maintenance-status",
    },
    { text: "Companies", icon: <CompaniesIcon />, route: "new-company" },
    {
      text: "All Users",
      icon: <AllUsersIcon />,
      route: "all-users",
    },
    {
      text: "Infra",
      icon: <RocketLaunchIcon />,
      route: "infra",
    },
    {
      text: "Demo Data",
      icon: <DemoDataIcon />,
      route: "demo-data",
    },
    {
      text: "Config Staging",
      icon: <ConfigStagingIcon />,
      route: "config-staging",
    },
  ];

  return (
    <div className={"app"}>
      <Navigation
        menuItems={menuItems}
        rightMenuComponent={<CompanySelector companyId={"global"} />}
        parentRoute={"/admin/global"}
      />
      <Routes>
        <Route path={"maintenance-status/*"} element={<MaintenanceStatus />} />
        <Route path={"new-company/*"} element={<NewCompany />} />
        <Route path={"infra/*"} element={<Infra />} />
        <Route path={"config-staging/*"} element={<ConfigStagingPage />} />
        <Route path={"all-users"} element={<AllUsersPage />} />
        <Route path={"demo-data"} element={<DemoDataProgress />} />
        <Route
          path={"*"}
          element={<Navigate to={"maintenance-status"} replace={true} />}
        />
      </Routes>
      <Footer />
    </div>
  );
};

export default GlobalConsole;
